import _ from 'lodash';
import React from 'react';
import { memberCostMethods } from '~/lookups';
import MultiSelect from '../MultiSelect';

const options = _.values(memberCostMethods);

export default function MemberCostMethodFilter({ placeholder = 'Member Labor Cost', name, value, onChange }) {
  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
